import { defineMessages } from 'react-intl';

const authMessages = defineMessages({
    sessionExpired: {
        id: 'auth.session.expired',
        description: 'Banner shown when the user is signed out after their session expires due to inactivity',
        defaultMessage: 'You have been logged out due to inactivity. You can log back in any time.'
    },
    dismissSessionExpired: {
        id: 'auth.session.expired.dismiss',
        description: 'Accessible label for the button that dismisses the session-expired banner',
        defaultMessage: 'Dismiss'
    }
});

export default authMessages;
